"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _commonMedia = require("@mmc/common-media");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _fiftyFifty = require("./fifty-fifty.propTypes");
var _fiftyFifty2 = _interopRequireDefault(require("../styles/fifty-fifty.css"));
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var IMAGE_SIZE = 1080;

/**
 * ## HalfImage - component
 *
 * This sub-component of Fiftyfifty component is to address image data.
 */

var isEmpty = function isEmpty(value) {
  return value !== ' ' && value !== '' && value !== undefined && value !== null;
};
var HalfImage = function HalfImage(_ref) {
  var _clsx;
  var data = _ref.data,
    aspectRatio = _ref.aspectRatio,
    carAlignment = _ref.carAlignment,
    theme = _ref.theme;
  var imagePath = handleNestedProp(data, 'data.image.image');
  var videoPath = handleNestedProp(data, 'data.video.source');
  var youtubeVideoId = handleNestedProp(data, 'data.video.youtubeVideoId');
  var hasImage = isEmpty(imagePath);
  var hasVideo = isEmpty(videoPath);
  var hasYoutube = isEmpty(youtubeVideoId);
  var alignCarLeft = carAlignment === 'left';
  return hasImage || hasVideo || hasYoutube ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(_fiftyFifty2["default"].imageWrap, _fiftyFifty2["default"]["aspect-" + aspectRatio], (_clsx = {}, _clsx[_fiftyFifty2["default"].alignRight] = alignCarLeft, _clsx[_fiftyFifty2["default"].videoWrapper] = alignCarLeft && hasVideo, _clsx))
  }, /*#__PURE__*/_react["default"].createElement(_commonMedia.CommonMedia, {
    theme: theme,
    mediaClasses: hasVideo ? [_fiftyFifty2["default"].backgroundImage, _fiftyFifty2["default"].backgroundVideo] : [_fiftyFifty2["default"].backgroundImage],
    size: IMAGE_SIZE,
    sizes: "(min-width: 768px) 50vw, 100vw",
    image: data.image,
    video: data.video,
    hideVideoOnMobile: data.hideVideoOnMobile,
    autoPlayVideoOnMobile: data.autoPlayVideoOnMobile
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _fiftyFifty2["default"].noImageWrap
  });
};
HalfImage.displayName = 'HalfImage';
var _default = HalfImage;
exports["default"] = _default;